// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"3f7bbb41","513":"a80eebde","703":"39ccd6e4","787":"8ac8aa7e"}[chunkId] + ".chunk.js";
};